// Hover-intent for the desktop navigation.
// Pure CSS :hover closes the mega menu / dropdown instantly the moment the
// cursor leaves the (narrow) menu item, so a slight move down or sideways makes
// it vanish. Keeping an `is-open` class for a short delay after the cursor
// leaves lets the menu stay open while the pointer travels toward it.
//
// The same delay drives an `is-menu-open` class on the header, so the header's
// hover appearance (background, text/logo colours) reverts together with the
// menu instead of snapping back before the menu has closed.
(function () {
  const CLOSE_DELAY = 300; // ms the menu stays open after the cursor leaves

  const nav = document.querySelector('.header-navigation');

  if (!nav) {
    return;
  }

  const header = document.querySelector('[data-header]');
  const items = nav.querySelectorAll('.header__item');
  let headerCloseTimer = null;

  const openHeader = () => {
    clearTimeout(headerCloseTimer);

    if (header) {
      header.classList.add('is-menu-open');
    }
  };

  const closeHeader = () => {
    clearTimeout(headerCloseTimer);
    headerCloseTimer = setTimeout(() => {
      if (header) {
        header.classList.remove('is-menu-open');
      }
    }, CLOSE_DELAY);
  };

  items.forEach((item) => {
    // Only items that actually have a flyout (mega menu or dropdown).
    if (!item.querySelector('.menu-mega, .header__dropdown')) {
      return;
    }

    let closeTimer = null;

    const open = () => {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      openHeader();
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        item.classList.remove('is-open');
      }, CLOSE_DELAY);
      closeHeader();
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);

    // Keyboard accessibility: keep it open while focus is inside the item.
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        scheduleClose();
      }
    });
  });
})();
